import {
  ChoseActionForBulkOfferUpdateEventLabel,
  ChoseActionForBulkOfferUpdateUserAction,
  RequestDataForNotableLikersUserAction,
  UserAction,
  UserDropdownNavigationFinishedUserAction,
  UserDropdownNavigationStartedUserAction,
  UserDropdownOpeningUserAction
} from '../../types/user-actions';

export const isUserDropdownOpeningUserAction = (
  action?: UserAction
): action is UserDropdownOpeningUserAction => (
  action !== undefined
  && action.eventCategory === 'drop down'
  && action.eventAction === 'open menu'
);

export const isUserDropdownNavigationStartedUserAction = (
  action?: UserAction
): action is UserDropdownNavigationStartedUserAction => (
  action !== undefined && action.eventCategory === 'drop down'
  && action.eventAction === 'navigate' && action.stage === 'start'
);

export const isUserDropdownNavigationFinishedUserAction = (
  action?: UserAction
): action is UserDropdownNavigationFinishedUserAction => (
  action !== undefined && action.eventCategory === 'drop down'
  && action.eventAction === 'navigate' && action.stage === 'finish'
);

export const isChoseActionForBulkOfferUpdateUserAction = (
  action?: UserAction
): action is ChoseActionForBulkOfferUpdateUserAction => (
  action !== undefined && action.eventCategory === 'bulk update offer details'
  && action.eventAction === 'choose an action'
);

export const isRequestDataForNotableLikersUserAction = (
  action?: UserAction
): action is RequestDataForNotableLikersUserAction => (
  action !== undefined && action.eventCategory === 'notable likers'
  && action.eventAction === 'request data'
);

export const getChoseActionForBulkOfferUpdateEventLabel = (
  chosenAction: string
): ChoseActionForBulkOfferUpdateEventLabel => {
  switch (chosenAction) {
    case 'postpone':
      return 'postpone task';
    case 'replace_timeline':
      return 'change task timeline';
    case 'replace_colored_tag':
      return 'add or replace task card tags';
    case 'replace_description':
      return 'add or replace description';
    case 'add_hashtags':
      return 'add hashtags';
    case 'replace_hashtags':
      return 'replace hashtags';
    case 'add_tags':
      return 'add tags';
    case 'replace_tags':
      return 'replace tags';
    case 'add_mentions':
      return 'add mentions';
    case 'replace_mentions':
      return 'replace mentions';
    default:
      throw new Error('Unexpected action selected. Potentially corrupt data for GA.');
  }
};
